import React from "react";
import { defineMessages } from "react-intl";
import { useDispatch } from "react-redux";
import { Button } from "../../../components/button/Buttons.js";
import "../../../components/button/EditButton.js";
import "../../../components/download/DownloadCsvButton.js";
import { DownloadTemplate } from "../../../components/download/DownloadTemplate.js";
import { Dropzone } from "../../../components/dropzone/Dropzone.js";
import { LocalizedText } from "../../../components/i18n/LocalizedText.js";
import { BulkModalContent } from "../../../components/modal/BulkModalContent.js";
import "../../../components/modal/BulkModalProvider.js";
import { BulkModalTitle } from "../../../components/modal/BulkModalTitle.js";
import "../../../components/modal/ModalButtons.js";
import { ModalFooter } from "../../../components/modal/ModalFooter.js";
import "@mui/material";
import "../../../components/modal/Modal.style.js";
import "../../../components/error/ErrorAccordion.js";
import "../../../components/error/ErrorDetails.js";
import "../../../components/error/localize.js";
import "../../../components/error/ErrorModal.js";
import "../../../components/error/GlobalServerErrorMessage.js";
import "../../../components/icons/Icon.js";
import "../../../components/icons/ExpandMoreIcon.js";
import "@opentelemetry/api";
import "../../../otel/TraceProvider.js";
import "react-error-boundary";
import "rxjs/operators";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "../../../components/modal/types.js";
import "../../../components/modal/ActionConfirmationModal.js";
import { bulkActionsActions } from "../../bulk-operation/actions.js";
import "../../bulk-operation/components/BulkActionButton.js";
import "../../bulk-operation/epics.js";
import { useSelectedItems } from "../../bulk-operation/hooks.js";
import "../../bulk-operation/reducers.js";
import "../../bulk-operation/selectors.js";
import "rxjs";
import "../../../api/types.js";
import "immer";
import "moment-timezone";
import "@apollo/client/errors";
import "@apollo/client";
import "graphql";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import "../../bulk-operation/components/BulkExecutionStepDetailsContent.js";
import "../../bulk-operation/components/BulkExecutionStepModal.js";
import "../../bulk-operation/components/BulkSummaryStepActionItem.js";
import "../../bulk-operation/components/BulkSummaryStepHoc.js";
import "../../../components/chip/ChipRenderer.js";
import "../../../components/chip/Chips.js";
import "../../../components/chip/ListWithChipTooltip.js";
import "../../../components/chip/SquaredChipList.js";
import "../../bulk-operation/components/DataGrid.js";
import "../../bulk-operation/components/BulkStepValidationSummary.js";
import "../../../components/progress/CircularProgress.js";
import "../../../components/progress/CircularProgressWithLabel.js";
import "../../bulk-operation/components/BulkSummaryStepActionLabel.js";
import { transactionActions } from "../actions.js";
const localized = defineMessages({
  cancelAction: {
    id: "BulkTransactionP2PTransferUploadStepModal_uploadFileStepFooterCancel",
    defaultMessage: "Cancel"
  },
  confirmAction: {
    id: "BulkTransactionP2PTransferUploadStepModal_uploadFileStepFooterConfirm",
    defaultMessage: "Next"
  },
  title: {
    id: "BulkTransactionP2PTransferUploadStepModal_title",
    defaultMessage: "Upload File Batch P2P Transfer"
  },
  downloadTemplateType: {
    id: "BulkTransactionP2PTransferUploadStepModal_downloadTemplateType",
    defaultMessage: "Batch P2P Transfer"
  }
});
function BulkTransactionP2PTransferUploadStepModal({ onNext, onPrev, strategy }) {
  const selectedItems = useSelectedItems();
  const dispatch = useDispatch();
  function handleCancelClick() {
    onPrev();
  }
  function handleNextClick() {
    onNext();
  }
  function handleFileUpload(file) {
    const loadStrategyProcessPayload = {
      strategy,
      request: { filePayload: { file }, keys: ["uid", "finance.balance", "username"] }
    };
    dispatch(bulkActionsActions.loadItems(loadStrategyProcessPayload));
  }
  function handleInvalidFileUpload() {
    dispatch(bulkActionsActions.clearBulkActions());
  }
  function handleDownloadTemplate() {
    dispatch(transactionActions.downloadBulkP2PTransferTemplate());
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(BulkModalTitle, null, /* @__PURE__ */ React.createElement(LocalizedText, { label: localized.title })), /* @__PURE__ */ React.createElement(BulkModalContent, null, /* @__PURE__ */ React.createElement(
    Dropzone,
    {
      availableFormats: ["XLSX", "CSV"],
      maxSizeInMB: 5,
      onFileUpload: handleFileUpload,
      onInvalidFileUpload: handleInvalidFileUpload
    }
  ), /* @__PURE__ */ React.createElement(DownloadTemplate, { title: localized.downloadTemplateType, onDownload: handleDownloadTemplate })), /* @__PURE__ */ React.createElement(ModalFooter, null, /* @__PURE__ */ React.createElement(Button, { label: localized.cancelAction, onClick: handleCancelClick }), /* @__PURE__ */ React.createElement(Button, { color: "primary", label: localized.confirmAction, onClick: handleNextClick, disabled: !selectedItems.length })));
}
export {
  BulkTransactionP2PTransferUploadStepModal,
  localized
};
//# sourceMappingURL=BulkP2PTransferUploadStepModal.js.map
